export const invoiceStatusList = ["no_invoice", "to_invoice", "invoiced"];
